import styled from 'styled-components';

export const Block = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 15px;

  .checkbox {
    margin: 0 30px 0 0;
    input {
      margin-right: 10px;
      border: 1px solid #ccc;
    }
    label {
      cursor: pointer;
    }
  }
`;
